import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();
CwThemeFramework.openImageInNewWindow();
/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 1200px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'quick-links-slider': 'quick-links-carousel',
    'es-quick-links-slider': 'es-quick-links-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
    'team-slider': 'team-carousel',
    'team-slider-interior': 'team-interior-carousel',
    'grid-videos': 'videos-carousel',
    'faq-videos-slider': 'faq-videos-carousel',
    'our-team': 'team-sidebar-widget',
    'front-locations-slider': 'front-locations-carousel',
    'related-information-slider': 'related-information-carousel',
    'about-five-logos-slider': 'about-five-logos-carousel',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const noFeeItem = new MatchHeight('.no-fee-item');
const commandersItem = new MatchHeight('.com-sec');
const aboutULitem = new MatchHeight('.about-three__facts');
const contactSidebarItem = new MatchHeight('.contact-sidebar-item');

// Match height per row only for caring page sponsor logos
// Manual row-based height matching for floated elements
if (document.querySelector('.sponsor-list-item')) {
    window.addEventListener('load', () => {
        function matchHeightByRow() {
            const items = document.querySelectorAll('.sponsor-list-item');
            if (!items.length) return;
            
            // Reset all heights first
            items.forEach(item => {
                item.style.height = 'auto';
            });
            
            // Group items by row (based on offsetTop)
            const rows = {};
            items.forEach((item, index) => {
                const top = item.offsetTop;
                if (!rows[top]) {
                    rows[top] = [];
                }
                rows[top].push(item);
            });
            
            // Match heights within each row
            Object.values(rows).forEach(rowItems => {
                let maxHeight = 0;
                
                // Find max height in this row
                rowItems.forEach(item => {
                    const height = item.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                
                // Apply max height to all items in this row
                rowItems.forEach(item => {
                    item.style.height = maxHeight + 'px';
                });
            });
        }
        
        // Initial match
        setTimeout(matchHeightByRow, 100);
        
        // Re-match on window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(matchHeightByRow, 250);
        });
    });
}

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

/**
 * About Us Numbers Counter Animation (Desktop Only)
 */
const aboutNumbersSection = document.querySelector('.about-two__number');
if (aboutNumbersSection) {
    CwLoadModules.aboutNumbersCounter().then((counterModule) => {
        counterModule();
    });
}

/**
 * Jump to Department Pills - Staff Directory
 * Smooth scroll to department sections when pills are clicked
 */
const jumpPills = document.querySelectorAll('.jump-pill');
if (jumpPills.length > 0) {
    // Function to get actual header height dynamically
    function getHeaderOffset() {
        const Mobile = window.innerWidth <= 767;
        const header = document.querySelector('header') || document.querySelector('.header') || document.querySelector('.site-header');
        if (header) {
            //return header.offsetHeight + 10;
            if (Mobile) {
                return header.offsetHeight + 10;
            } else {
                return header.offsetHeight - 150; // Add 20px buffer
            }
            
        }
        // Fallback values if header not found
        return window.innerWidth < 1200 ? 200 : 130;
    }
    
    jumpPills.forEach((pill) => {
        pill.addEventListener('click', function(event) {
            event.preventDefault();
            
            // Get target department ID from data attribute
            const targetId = this.getAttribute('data-target');
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                // Remove active class from all pills
                document.querySelectorAll('.jump-pill').forEach(p => p.classList.remove('active'));
                
                // Add active class to clicked pill
                this.classList.add('active');
                
                // Smooth scroll to target with offset for fixed header
                // Calculate actual header height dynamically
                const headerOffset = getHeaderOffset();
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}